<template>
  <WithCustomSidebar :config="sidebarConfig">
    <Content class="app-view">
      <div class="row">
        <div class="small-12 large-12 columns">
          <AppAlert />
        </div>

        <div class="columns">
          <AppHeader />
        </div>
      </div>

      <hr class="divider" />

      <div class="app-view__content">
        <Transition name="fade-transform" mode="out-in">
          <RouterView
            @esra-needs-request-change="updateEsraNeedsRequest"
          />
        </Transition>
      </div>
    </Content>
  </WithCustomSidebar>
</template>

<script>
import Content from '@@/common/layout/Content';
import AppHeader from './AppHeader';
import AppAlert from './AppAlert';
import layout from '@/mixins/layout';
import permissions from '@/mixins/permissions';
import packageName from '@/mixins/packageName';
import lang from '@/mixins/lang';
import appSidebarConfig from '@@/layout/Sidebar/configs/appSidebar';
import WithCustomSidebar from '@@/layout/Sidebar/WithCustomSidebar';

import { Apps } from '@/api/api';
import useAuth from '@/auth';
import { mapGetters } from 'vuex';
import { APP_DETAILS } from '@/store/types';
const auth = useAuth();

export default {
  name: 'AppView',

  components: {
    WithCustomSidebar,
    Content,
    AppAlert,
    AppHeader,
  },

  mixins: [layout, permissions, packageName, lang],

  data() {
    return {
      esraNeedsRequest: false,
    };
  },

  computed: {
    ...mapGetters({ app: APP_DETAILS }),
    isIranian() {
      const { publisher = {} } = auth.user;
      return publisher.country === 'IR';
    },
    isGame() {
      return this.app.category?.game;
    },
    sidebarConfig() {
      const sidebarArgs = {
        hasStatistics: this.hasStatistics(this.packageName),
        hasChangeAppInfo: this.hasChangeAppInfo(this.packageName),
        hasDevelopment: this.hasDevelopment(this.packageName),
        hasFinance: this.hasFinance(this.packageName),
        hasSupport: this.hasSupport(this.packageName),
        hasOAuth: this.hasOAuth,
        esraNeedsRequest: this.esraNeedsRequest,
        alphaEnabled: this.app.alphaEnabled,
        betaEnabled: this.app.betaEnabled,
      };

      return appSidebarConfig(sidebarArgs);
    },
  },

  created() {
    this.setPageTitle('APPS.TITLE');
  },

  watch: {
    packageName: {
      immediate: true,
      handler(packageName) {
        if (this.$route.name === 'app-info') return;
        this.fetchEsraStatus(packageName);
      },
    },
  },

  methods: {
    fetchEsraStatus(packageName) {
      this.esraNeedsRequest = false;

      if (!this.hasChangeAppInfo(packageName)) return Promise.resolve();

      return Apps.getBasicInfo({ packageName })
        .then(({ body: { esra_needs_request: needsRequest = false } = {} }) => {
          if (packageName !== this.packageName) return;
          this.esraNeedsRequest = needsRequest === true;
        })
        .catch(() => {});
    },
    updateEsraNeedsRequest(needsRequest) {
      this.esraNeedsRequest = needsRequest === true;
    },
  },
};
</script>

<style lang="scss">
.app-view {
  &__content {
    margin-top: $global-margin * 2;
  }
}
</style>
